import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "@/App";
import "@/styles/main.scss";
import { Analytics } from "@/components";
import { AuthProvider, TenantProvider } from "@/contexts";
import { queryClient } from "@/lib/queryClient";
import { bootstrapDocumentTenant } from "@/utils/documentTenantBootstrap";
import { BrowserRouter } from "react-router-dom";

if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

bootstrapDocumentTenant();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <TenantProvider>
            <Analytics>
              <App />
            </Analytics>
          </TenantProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
